module.exports = __webpack_public_path__ + "static/img/fullscreen-image_explore-your-options_fr_768.2b5d547.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/training/fullscreen-image_explore-your-options_fr_768.png
// module id = TaKn
// module chunks = 0